// extracted by mini-css-extract-plugin
export default {"content":"PatientDetailsForm__content--pCgVq"};